import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

const ADMIN_CREDENTIALS = {
  email: 'skill@samhita.org',
  password: 'Samhita@123'
};

const ADMIN_SESSION_KEY = 'adminSession';

export interface AdminUser {
  email: string;
  isAuthenticated: boolean;
  loginTime: number;
}

@Injectable({
  providedIn: 'root'
})
export class AdminAuthService {

  constructor(private router: Router) { }

  login(email: string, password: string): { success: boolean; message: string } {
    if (email === ADMIN_CREDENTIALS.email && password === ADMIN_CREDENTIALS.password) {
      const adminUser: AdminUser = {
        email,
        isAuthenticated: true,
        loginTime: Date.now()
      };
      localStorage.setItem(ADMIN_SESSION_KEY, JSON.stringify(adminUser));
      return { success: true, message: 'Login successful' };
    }
    return { success: false, message: 'Invalid email or password' };
  }

  logout(): void {
    localStorage.removeItem(ADMIN_SESSION_KEY);
    this.router.navigate(['/admin/login']);
  }

  isAuthenticated(): boolean {
    const session = localStorage.getItem(ADMIN_SESSION_KEY);
    if (!session) return false;
    
    try {
      const adminUser: AdminUser = JSON.parse(session);
      return adminUser.isAuthenticated === true;
    } catch {
      return false;
    }
  }

  getAdminUser(): AdminUser | null {
    const session = localStorage.getItem(ADMIN_SESSION_KEY);
    if (!session) return null;
    
    try {
      return JSON.parse(session);
    } catch {
      return null;
    }
  }
}

